var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEndGame(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27 0C41.8878 0 54 12.1095 54 27C54 41.8878 41.8878 54 27 54C18.5571 54 10.7541 50.1579 5.5971 43.4646C4.9356 42.6033 5.0949 41.3694 5.9562 40.7106C6.8121 40.0464 8.0433 40.2111 8.7075 41.067C13.1166 46.791 19.7829 50.0742 27 50.0742C39.7224 50.0742 50.0742 39.7251 50.0742 27C50.0742 14.2776 39.7224 3.9258 27 3.9258C14.2776 3.9258 3.9258 14.2776 3.9258 27C3.9258 28.1826 4.0149 29.3571 4.1904 30.5073C4.3524 31.5765 3.618 32.5782 2.5461 32.7429C1.4688 32.9211 0.4725 32.1732 0.3105 31.1013C0.1053 29.7567 0 28.377 0 27C0 12.1095 12.1122 0 27 0ZM27.0275 35.2239C28.1453 35.2239 29.0525 36.1311 29.0525 37.2489C29.0525 38.3667 28.1453 39.2739 27.0275 39.2739C25.9097 39.2739 24.989 38.3667 24.989 37.2489C24.989 36.1311 25.8827 35.2239 27.0005 35.2239H27.0275ZM27 14.7261C28.1178 14.7261 29.025 15.6333 29.025 16.7511V28.6851C29.025 29.8029 28.1178 30.7101 27 30.7101C25.8822 30.7101 24.975 29.8029 24.975 28.6851V16.7511C24.975 15.6333 25.8822 14.7261 27 14.7261Z",
    fill: "#4569FF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEndGame);
export default __webpack_public_path__ + "static/media/endGame.ab442f75.svg";
export { ForwardRef as ReactComponent };